jQuery(document).ready(function ($) {

    $('.locations ul li').click(function () {
        var tab_id = $(this).attr('data-location');



        $('.locations ul li').removeClass('active');
        $('.b .view').removeClass('active');
        $('.gmaps').removeClass('current');

        $(this).addClass('active');

        $(".b").find("[data-location-view='" + tab_id + "']").addClass('active');
        $("#maps").find("[data-map-id='" + tab_id + "']").addClass('current');
        initMap();

        if(tab_id === '1') {
            window.location.hash = 'rejtana';
        }
        else if(tab_id === '2') {
            window.location.hash = 'krakowska';
        }
        else if(tab_id === '3') {
            window.location.hash = 'mielec';
        }
        else if(tab_id === '4') {
            window.location.hash = 'tarnow';
        }
    });

    var hash = window.location.hash;

    function change_location(tab_id) {
        $('.locations ul li').removeClass('active');
        $('.b .view').removeClass('active');
        $('.gmaps').removeClass('current');

        $('.locations ul').find("[data-location='" + tab_id + "']").addClass('active');

        $(".b").find("[data-location-view='" + tab_id + "']").addClass('active');
        $("#maps").find("[data-map-id='" + tab_id + "']").addClass('current');
        initMap();
    }

    var tab_id;

    if (hash === '#rejtana') {
        tab_id = 1;
        change_location(tab_id);
    }
    else if (hash === '#krakowska') {
        tab_id = 2;
        change_location(tab_id);
    }
    else if (hash === '#mielec') {
        tab_id = 3;
        change_location(tab_id);
    }
    else if (hash === '#tarnow') {
        tab_id = 4;
        change_location(tab_id);
    }
});
